import styled from "styled-components";

export const BuscadorEstudioContainer = styled.div`
  width: 100vw;
  .btn-VerificaOs {
    border-radius: 8px;
  }
`;
export const BuscadorEstudioBody = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  
`;
export const BuscadorEstudioCarouselBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  
  .BuscadorEstudio-btnAvanzar {
    background-color: var(--color-broccoli);
    color: var(--color-white);
    border-radius: 8px;
    height: 42px;
    width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;
export const BuscadorEstudioHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .BuscadorEstudio-input-container {
    position: relative;
    width: 630px;
  }
  .BuscadorEstudio-pacienteSeleccionado {
    position: absolute;
    top: 14px;
    left: 640px;
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #023755;
  }
  .BuscadorEstudio-pacienteSeleccionado-bold {
    font-weight: bold;
  }
`;
export const BuscadorEstudioGrid = styled.div``;

export const BuscadorEstudioCurva = styled.div`
  background-color: var(--color-latex10);
  height: 40px;
  border-radius: 50%;
  width: 120vw;
  position: absolute;
  top: -20px;
  background-color: var(--color-latex10);
`;
export const BuscadorEstudioFooter = styled.div`
  background-color: var(--color-latex10);
  height: 200px;
  width: 100vw;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
`;

export const BuscadorEstudioTecladoContainer = styled.div`
  width: 808px;
  z-index: 1;
`;
